import { handleStringToObj } from "./commonUtils"


const localStorageGetItem = (key: string): string | null => {
  return localStorage.getItem(key)
}

const localStorageSetItem = (key: string, value: string): void => {
  localStorage.setItem(key, value)
}

const localStorageRemoveItem = (key: string): void => {
  localStorage.removeItem(key)
}

const localStorageGetItemObject = (key: string) => {
  const value = localStorage.getItem(key)
  return handleStringToObj(value, {})
}

const localStorageSetItemObject = (key: string, value: object): void => {
  localStorage.setItem(key, JSON.stringify(value))
}

const localStorageClear = (excludeKeys: string[] = []): void => {
  const values: (string | null)[] = []
  excludeKeys.forEach((key) => {
    values.push(localStorageGetItem(key))
  })
  localStorage.clear()
  excludeKeys.forEach((key, index) => {
    const value = values[index]
    value && localStorageSetItem(key, value)
  })
}

const localStorageClearHelper = () => {
  if (process.env.NODE_ENV === 'development') {
    localStorageClear(['mockApi'])
  } else {
    localStorageClear()
  }
}

export { localStorageClear, localStorageClearHelper }

export {
  localStorageGetItem,
  localStorageSetItem,
  localStorageRemoveItem,
  localStorageGetItemObject,
  localStorageSetItemObject,
}
